<template>
  <div id="app" class="container-fluid">
    <!-- Header (UNCHANGED) -->
    <full_head />

    <!-- Main Content -->
    <div class="main-content">
      <div class="card investigations-card">
        <div class="card-header">
          <h3><i class="fas fa-flask"></i> Investigations & Lab Results</h3>
          <button class="btn-add" @click="showCreatePatientService">
            <i class="fas fa-plus"></i> Add Investigation
          </button>
        </div>
        <!-- <div class="investigations-header">
          <div class="header-left">
            <i class="fas fa-x-ray header-icon"></i>
            <div>
              <h3>Investigations</h3>
              <small class="text-muted">
                Laboratory tests for this patient
              </small>
            </div>
          </div>

          <button
            class="btn btn-outline-primary"
            @click="showCreatePatientService"
          >
            <i class="fas fa-plus"></i> Add Investigation
          </button>
        </div> -->

        <div v-if="loading">
          <loader />
        </div>

        <div v-if="!loading" class="card-body">
          <div class="table-responsive">
            <table class="table investigations-table">
              <thead>
                <tr>
                  <th scope="col">Test Number</th>
                  <th scope="col">Test Name</th>
                  <th scope="col">Status</th>
                  <th scope="col">Create Date</th>
                  <th class="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="service in services" :key="service.id">
                  <th scope="row">{{ service.id }}</th>
                  <td style="color: black">{{ service.service_name }}</td>
                  <td>
                    <span
                      v-if="service.attended == '0' || service.attended == null"
                      >Pending...</span
                    >
                    <span
                      v-if="service.attended == '1' || service.attended == 1"
                      >Ongoing...</span
                    >
                    <span
                      v-if="service.attended == '2' || service.attended == 2"
                      >Completed</span
                    >
                  </td>
                  <td>{{ formatDateTime(service.service_date) }}</td>
                  <!-- <td>{{ service.service_date }}</td> -->
                  <td class="text-end">
                    <a
                      v-if="
                        open_service(
                          service.is_invoice,
                          service.is_paid,
                          cash_bills_behavior,
                        )
                      "
                      :href="'/lab-details/' + service.id"
                      class="btn btn-sm btn-info button-touch"
                    >
                      Details</a
                    >.
                    <span
                      v-if="
                        !open_service(
                          service.is_invoice,
                          service.is_paid,
                          cash_bills_behavior,
                        )
                      "
                      style="
                        color: black;
                        background-color: pink;
                        padding: 1px;
                        margin: 2px;
                      "
                    >
                      !! Pending Payment !!
                    </span>
                    <button
                      class="btn btn-sm btn-danger button-touch"
                      v-if="service.attended != 1"
                      @click="removeTest(service.id)"
                    >
                      Delete Test
                    </button>
                  </td>
                </tr>
                <!-- ====================================== -->

                <tr v-if="services.length === 0">
                  <td colspan="6" class="text-center text-muted py-4">
                    No investigations ordered for this patient
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ConductLabtestModal
    v-if="show_add_lab_test_modal"
    @hide-create-test-model="hideCreateTestModel"
    :service_id="current_test"
  />

  <CreateServiceModal
    v-if="showAddServiceModal"
    :visitId="visit_id"
    @close-add-service-modal="showAddServiceModal = false"
  />

  <ViewLabResults
    v-if="showViewModal"
    :service_id="current_test"
    @close-view-result-modal="showViewModal = false"
  />
</template>

<script>
// import full_dental_head from "./full_eye_head.vue";
import CreateServiceModal from "../../../visits_management/add_patient_service_modal.vue";
import ConductLabtestModal from "../../../visits_management/lab/add_lab_test_modal.vue";
import { generalApiRequest } from "../../../../api/apiIndex";
import ViewLabResults from "../../../visits_management/lab/view_lab_results.vue";
import { get_setting } from "../../../../settings/get_setting";
import loader from "../../dialysis/loader.vue";
import { open_service } from "../../../../settings/get_setting";
import formatDateTime from "../../../../timezone/utc_local_time";

import full_head from "./full_head.vue";

export default {
  name: "PatientInvestigations",
  components: {
    full_head,
    ConductLabtestModal,
    // PatientInfo,
    CreateServiceModal,
    ViewLabResults,
    loader,
  },
  data() {
    return {
      visit_id: this.$route.params.visit_id,

      show_add_lab_test_modal: false,
      patient_id: null,
      showAddServiceModal: false,
      services: [],
      current_test: "",
      showViewModal: false,
      cash_bills_behavior: 0,
      loading: false,
    };
  },
  methods: {
    formatDateTime,
    open_service,
    navigate_loc(route) {
      window.location.href = route;
    },
    showViewTestModal(tid) {
      this.current_test = tid;
      this.showViewModal = true;
    },

    handleShowAddTestModal(tid) {
      this.current_test = tid;
      this.show_add_lab_test_modal = true;
      // You can pass the service info to the modal if needed
    },

    hideCreateTestModel() {
      this.show_add_lab_test_modal = false;
      window.location.reload();
    },

    showCreatePatientService() {
      this.showAddServiceModal = true;
    },

    async fetchServicesForVisit() {
      this.loading = true;
      const url = `services/for-visit/${this.visit_id}/2`;
      try {
        const response = await generalApiRequest(url, "GET", {}, 1);
        // console.log(response);

        this.services = response.data;

        const payment_setting = await get_setting("cash_bills_behavior");
        this.cash_bills_behavior = payment_setting.setting_value;
      } catch (error) {
        console.error("Error fetching services:", error);
      }
      this.loading = false;
    },

    async removeTest(serviceId) {
      const url = "services/delete/" + serviceId;
      const body = {};
      const res = await generalApiRequest(url, "GET", body, 1);
      if (res) {
        location.reload();
      }
    },

    editTest(serviceId) {
      this.current_test = serviceId;
      this.show_add_lab_test_modal = true;
    },

    async mountPastRecords() {
      const url = "get_all_visits_dates";
      const body = { visit_id: this.visit_id };
      const res = await generalApiRequest(url, "GET", body, 1);
      this.past_records = res.data;
      console.log(res.data);

      if (res.data.length > 0) {
        this.patient_id = res.data[0].patient_id;
      }
    },
  },
  mounted() {
    this.mountPastRecords();
    this.fetchServicesForVisit(); // Fetch services when the component is mounted
  },
};
</script>

<!-- <template>
  <div id="app" class="container-fluid">
    <full_head />

    <div class="main-content">
      <div class="card">
        <div class="card-header">
          <h3><i class="fas fa-flask"></i> Investigations & Lab Results</h3>
          <button class="btn-add" @click="showAddModal = true">
            <i class="fas fa-plus"></i> Add Investigation
          </button>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Test Date</th>
                  <th>Investigation Type</th>
                  <th>Test Name</th>
                  <th>Ordered By</th>
                  <th>Status</th>
                  <th>Results</th>
                  <th>Report</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="investigation in investigations" :key="investigation.id">
                  <td>{{ formatDate(investigation.testDate) }}</td>
                  <td>
                    <span class="type-badge" :class="getTypeClass(investigation.type)">
                      {{ investigation.type }}
                    </span>
                  </td>
                  <td>
                    <strong>{{ investigation.testName }}</strong>
                    <div v-if="investigation.panel" class="text-muted small">
                      Panel: {{ investigation.panel }}
                    </div>
                  </td>
                  <td>{{ investigation.orderedBy }}</td>
                  <td>
                    <span class="status-badge" :class="getStatusClass(investigation.status)">
                      {{ investigation.status }}
                    </span>
                  </td>
                  <td>
                    <div v-if="investigation.results">
                      <span v-if="investigation.isAbnormal" class="result-abnormal">
                        <i class="fas fa-exclamation-circle"></i>
                        Abnormal
                      </span>
                      <span v-else class="result-normal">
                        <i class="fas fa-check-circle"></i>
                        Normal
                      </span>
                    </div>
                    <span v-else class="text-muted">Pending</span>
                  </td>
                  <td>
                    <button 
                      v-if="investigation.reportAvailable"
                      class="btn-view-report"
                      @click="viewReport(investigation.id)"
                    >
                      <i class="fas fa-file-medical"></i>
                      View Report
                    </button>
                    <span v-else class="text-muted">Not Available</span>
                  </td>
                  <td class="actions">
                    <button class="btn-action edit" @click="editInvestigation(investigation)">
                      <i class="fas fa-edit"></i>
                    </button>
                    <button class="btn-action delete" @click="deleteInvestigation(investigation.id)">
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="investigations.length === 0">
                  <td colspan="8" class="text-center text-muted">
                    No investigations found. Click "Add Investigation" to order tests.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showAddModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ editingInvestigation ? 'Edit' : 'Add' }} Investigation</h3>
          <button class="modal-close" @click="closeModal">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveInvestigation">
            <div class="form-grid">
              <div class="form-group">
                <label>Test Date *</label>
                <input
                  type="date"
                  v-model="form.testDate"
                  required
                  class="form-control"
                />
              </div>

              <div class="form-group">
                <label>Investigation Type *</label>
                <select v-model="form.type" required class="form-control">
                  <option value="">Select Type</option>
                  <option value="Laboratory">Laboratory</option>
                  <option value="Radiology">Radiology</option>
                  <option value="Ultrasound">Ultrasound</option>
                  <option value="Cardiology">Cardiology</option>
                  <option value="Pathology">Pathology</option>
                  <option value="Microbiology">Microbiology</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div class="form-group">
                <label>Test Name *</label>
                <input
                  type="text"
                  v-model="form.testName"
                  required
                  class="form-control"
                  placeholder="e.g., Complete Blood Count, Urinalysis"
                />
              </div>

              <div class="form-group">
                <label>Test Panel/Group</label>
                <input
                  type="text"
                  v-model="form.panel"
                  class="form-control"
                  placeholder="e.g., LFT, RFT, Lipid Profile"
                />
              </div>

              <div class="form-group">
                <label>Ordered By *</label>
                <input
                  type="text"
                  v-model="form.orderedBy"
                  required
                  class="form-control"
                  placeholder="Doctor's name"
                />
              </div>

              <div class="form-group">
                <label>Status *</label>
                <select v-model="form.status" required class="form-control">
                  <option value="Pending">Pending</option>
                  <option value="Sample Collected">Sample Collected</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Completed">Completed</option>
                  <option value="Cancelled">Cancelled</option>
                </select>
              </div>

              <div class="form-group full-width">
                <label>Clinical Indication</label>
                <textarea
                  v-model="form.clinicalIndication"
                  class="form-control"
                  rows="2"
                  placeholder="Reason for test, clinical findings"
                ></textarea>
              </div>

              <div class="form-group">
                <label>Specimen Type</label>
                <input
                  type="text"
                  v-model="form.specimenType"
                  class="form-control"
                  placeholder="e.g., Blood, Urine, Sputum"
                />
              </div>

              <div class="form-group">
                <label>Result Date</label>
                <input
                  type="date"
                  v-model="form.resultDate"
                  class="form-control"
                  :disabled="form.status !== 'Completed'"
                />
              </div>

              <div class="form-group full-width">
                <label>Results Summary</label>
                <textarea
                  v-model="form.results"
                  class="form-control"
                  rows="3"
                  placeholder="Enter test results or findings"
                  :disabled="form.status !== 'Completed'"
                ></textarea>
              </div>

              <div class="form-group">
                <label>
                  <input
                    type="checkbox"
                    v-model="form.isAbnormal"
                    :disabled="form.status !== 'Completed'"
                  />
                  Abnormal Result
                </label>
              </div>

              <div class="form-group">
                <label>
                  <input
                    type="checkbox"
                    v-model="form.reportAvailable"
                    :disabled="form.status !== 'Completed'"
                  />
                  Report Available
                </label>
              </div>
            </div>

            <div class="modal-actions">
              <button
                type="button"
                class="btn btn-secondary"
                @click="closeModal"
              >
                Cancel
              </button>
              <button type="submit" class="btn btn-primary">
                {{ editingInvestigation ? 'Update' : 'Save' }} Investigation
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template> -->
<!-- 
<script>
import full_head from "./full_head.vue";

export default {
  name: "Investigations",
  components: {
    full_head,
  },
  data() {
    return {
      showAddModal: false,
      editingInvestigation: null,
      form: {
        testDate: new Date().toISOString().split("T")[0],
        type: "Laboratory",
        testName: "",
        panel: "",
        orderedBy: "",
        status: "Pending",
        clinicalIndication: "",
        specimenType: "",
        resultDate: "",
        results: "",
        isAbnormal: false,
        reportAvailable: false,
      },
      investigations: [
        {
          id: 1,
          testDate: "2023-11-15",
          type: "Laboratory",
          testName: "Complete Blood Count",
          panel: "CBC",
          orderedBy: "Dr. Jane Smith",
          status: "Completed",
          results: "Within normal limits",
          isAbnormal: false,
          reportAvailable: true,
          resultDate: "2023-11-15",
        },
        {
          id: 2,
          testDate: "2023-11-15",
          type: "Laboratory",
          testName: "Urinalysis",
          panel: "",
          orderedBy: "Dr. Jane Smith",
          status: "Completed",
          results: "Protein +, Glucose negative",
          isAbnormal: true,
          reportAvailable: true,
          resultDate: "2023-11-15",
        },
        {
          id: 3,
          testDate: "2023-11-20",
          type: "Ultrasound",
          testName: "Obstetric Ultrasound",
          panel: "",
          orderedBy: "Dr. Jane Smith",
          status: "Completed",
          results: "Single live fetus, appropriate for dates",
          isAbnormal: false,
          reportAvailable: true,
          resultDate: "2023-11-20",
        },
        {
          id: 4,
          testDate: "2023-12-01",
          type: "Laboratory",
          testName: "Oral Glucose Tolerance Test",
          panel: "OGTT",
          orderedBy: "Dr. Jane Smith",
          status: "Pending",
          results: "",
          isAbnormal: false,
          reportAvailable: false,
          resultDate: "",
        },
        {
          id: 5,
          testDate: "2023-12-05",
          type: "Radiology",
          testName: "Chest X-Ray",
          panel: "",
          orderedBy: "Dr. Mary Johnson",
          status: "Sample Collected",
          results: "",
          isAbnormal: false,
          reportAvailable: false,
          resultDate: "",
        },
      ],
    };
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    
    getTypeClass(type) {
      const classes = {
        Laboratory: "type-lab",
        Radiology: "type-radiology",
        Ultrasound: "type-ultrasound",
        Cardiology: "type-cardio",
        Pathology: "type-pathology",
        Microbiology: "type-micro",
        Other: "type-other",
      };
      return classes[type] || "type-default";
    },
    
    getStatusClass(status) {
      const classes = {
        Pending: "status-pending",
        "Sample Collected": "status-collected",
        "In Progress": "status-progress",
        Completed: "status-completed",
        Cancelled: "status-cancelled",
      };
      return classes[status] || "status-default";
    },
    
    viewReport(id) {
      // Navigate to report view page
      console.log(`Viewing report for investigation ID: ${id}`);
      // Example navigation:
      // this.$router.push(`/investigations/report/${id}`);
    },
    
    editInvestigation(investigation) {
      this.editingInvestigation = investigation;
      this.form = { ...investigation };
      this.showAddModal = true;
    },
    
    deleteInvestigation(id) {
      if (confirm("Are you sure you want to delete this investigation?")) {
        this.investigations = this.investigations.filter(
          (inv) => inv.id !== id
        );
      }
    },
    
    closeModal() {
      this.showAddModal = false;
      this.editingInvestigation = null;
      this.resetForm();
    },
    
    resetForm() {
      this.form = {
        testDate: new Date().toISOString().split("T")[0],
        type: "Laboratory",
        testName: "",
        panel: "",
        orderedBy: "",
        status: "Pending",
        clinicalIndication: "",
        specimenType: "",
        resultDate: "",
        results: "",
        isAbnormal: false,
        reportAvailable: false,
      };
    },
    
    saveInvestigation() {
      const investigationData = {
        ...this.form,
        id: this.editingInvestigation ? this.editingInvestigation.id : Date.now(),
        reportAvailable: this.form.status === "Completed" ? this.form.reportAvailable : false,
        resultDate: this.form.status === "Completed" ? (this.form.resultDate || new Date().toISOString().split("T")[0]) : "",
      };

      if (this.editingInvestigation) {
        const index = this.investigations.findIndex(
          (inv) => inv.id === this.editingInvestigation.id
        );
        this.investigations[index] = investigationData;
      } else {
        this.investigations.push(investigationData);
      }

      // Sort by test date (newest first)
      this.investigations.sort(
        (a, b) => new Date(b.testDate) - new Date(a.testDate)
      );

      this.closeModal();
    },
  },
};
</script> -->

<style scoped>
.container-fluid {
  padding: 20px;
  background-color: #f8f9fa;
}

.main-content {
  margin-top: 20px;
}

.card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  border: none;
  overflow: hidden;
}

.card-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 20px;
  border-bottom: 2px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header h3 {
  margin: 0;
  color: #495057;
  font-size: 20px;
  font-weight: 600;
}

.card-header h3 i {
  margin-right: 10px;
  color: #667eea;
}

.btn-add {
  padding: 8px 20px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: 600;
}

.btn-add:hover {
  background: #218838;
}

.card-body {
  padding: 25px;
}

.table-responsive {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th {
  background: #f8f9fa;
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
  white-space: nowrap;
}

.table td {
  padding: 12px;
  border-bottom: 1px solid #e9ecef;
  vertical-align: middle;
}

.type-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  min-width: 80px;
}

.type-lab {
  background: #e8f4fd;
  color: #2980b9;
}

.type-radiology {
  background: #fce4ec;
  color: #c2185b;
}

.type-ultrasound {
  background: #f3e5f5;
  color: #7b1fa2;
}

.type-cardio {
  background: #f1f8e9;
  color: #689f38;
}

.type-pathology {
  background: #fff3e0;
  color: #f57c00;
}

.type-micro {
  background: #e0f2f1;
  color: #00796b;
}

.type-other {
  background: #f5f5f5;
  color: #616161;
}

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  min-width: 100px;
}

.status-pending {
  background: #fff3cd;
  color: #856404;
}

.status-collected {
  background: #cce5ff;
  color: #004085;
}

.status-progress {
  background: #d1ecf1;
  color: #0c5460;
}

.status-completed {
  background: #d4edda;
  color: #155724;
}

.status-cancelled {
  background: #f8d7da;
  color: #721c24;
}

.result-normal {
  color: #28a745;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;
}

.result-abnormal {
  color: #dc3545;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;
}

.btn-view-report {
  padding: 6px 12px;
  background: #17a2b8;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  font-weight: 600;
}

.btn-view-report:hover {
  background: #138496;
}

.text-muted {
  color: #6c757d;
  font-style: italic;
}

.small {
  font-size: 12px;
}

.actions {
  display: flex;
  gap: 5px;
}

.btn-action {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-action.edit {
  background: #3498db;
  color: white;
}

.btn-action.edit:hover {
  background: #2980b9;
}

.btn-action.delete {
  background: #e74c3c;
  color: white;
}

.btn-action.delete:hover {
  background: #c0392b;
}

.text-center {
  text-align: center;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 10px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
}

.modal-close {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
}

.modal-body {
  padding: 30px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  color: #495057;
}

.form-control {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
}

.form-control:disabled {
  background-color: #e9ecef;
  cursor: not-allowed;
}

.form-group label input[type="checkbox"] {
  margin-right: 8px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}

.btn {
  padding: 10px 25px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #5a6268;
}

.btn-primary {
  background: #667eea;
  color: white;
}

.btn-primary:hover {
  background: #5a6fd8;
}

@media (max-width: 1200px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .container-fluid {
    padding: 10px;
  }

  .table {
    font-size: 14px;
  }

  .table th,
  .table td {
    padding: 8px;
  }

  .card-header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }

  .btn-add {
    align-self: stretch;
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .table-responsive {
    overflow-x: auto;
  }

  .table {
    min-width: 800px;
  }

  .modal-content {
    width: 95%;
  }
}
</style>
